<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin correctly for Chart.js v2
Chart.plugins.register(ChartDataLabels);

export default {
  name: "gru-chart",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: "canvas"
    },
    type: {
      type: String,
      default: "pie" // Default to pie chart
    },
    legend: {
      type: Boolean,
      default: true // Default to pie chart
    },
    titleprop: {
      type: String,
      default: ""
    },
    query: {
      type: String,
      default: ""
    },
    search: {
      type: Object,
      default: () => {}
    },
    label: {
      type: Array,
      default: () => []
    },
    labelField: {
      type: String,
      default: null
    },
    indexField: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      chartInstance: null,
      chartData: [],
      chartLabel: [],
      chartColor: [],
      title: "",
      titleArr: []
    };
  },

  watch: {
    query() {
      this.getData();

    },
    search: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
    label(data) {
      this.chartLabel = [];
      this.chartColor = [];
      data.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    }
  },

  created() {
    this.getData();
    //
  },

  methods: {
    async getData() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/chart/query?query=${this.query}`, this.search);
        this.initChart();
        this.chartData = [];
        this.chartLabel = [];
        if(response.list.length === 0) {
          this.title = "Không có dữ liệu";
          return;
        }
        response.list.forEach(rs => {
          this.chartLabel.push(rs[this.labelField]);
          this.chartData.push(rs[this.indexField]);
        });
        this.title = response.title;
        this.subTitle = response.subTitle;
        this.titleArr =[];
        this.titleArr.push(this.title);
        if(this.subTitle != undefined){
          this.titleArr.push(this.subTitle);
        }
        this.createChart();
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    },

    initChart() {
      this.chartLabel = [];
      this.chartColor = [];
      this.label.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    },

    createChart() {
      const ctxmark = document.getElementById(this.id).getContext("2d");

      // Destroy old chart instance before creating a new one
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctxmark, {
        type: this.type,
        data: {
          labels: this.chartLabel,
          datasets: [
            {
              data: this.chartData,
              backgroundColor: this.chartColor
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          title: {
            display: true,
            text: this.titleArr,
            fontSize: 24, // ✅ Correct for Chart.js v2
            fontWeight: 'bold', // Optional, some versions support this
            fontColor: "black"
          },
          legend: {
            display: this.legend
          },
          onClick: (evt, elements) => {
            if (elements.length > 0) {
              const index = elements[0]._index;
              const label = this.chartInstance.data.labels[index];
              const value = this.chartInstance.data.datasets[0].data[index];
              this.$emit("clickPart", label);
            } else{
              this.$emit("clickPart", "1");
            }
          },
          plugins: {
            datalabels: { // Show text inside pie chart
              color: "#fff",
              anchor: "center",
              align: "center",
              font: {
                weight: "bold",
                size: 14
              },
              formatter: (value, ctx) => {
                // let label = ctx.chart.data.labels[ctx.dataIndex]; // Get label
                // return `${label}: ${value}`; // Show label + count
                // console.log("777", ctx.dataset)
                let sum = ctx.dataset.data.reduce((a, b) => Number(a) + Number(b), 0);
                let percent = ((value / sum) * 100).toFixed(1);
                if(percent <= 0){
                  return "";
                }
                let percentage = percent + "%";
                return percentage; // Show percentage inside slices
              }
            }
          }
        }
      });
      document.addEventListener("click", (event) => {
        const chartContainer = document.getElementById(this.id);
        if (chartContainer && !chartContainer.contains(event.target)) {
          this.$emit("clickOut");
        }
      });
    }
  },

};
</script>
